import 'regenerator-runtime/runtime';
import Vue from '../../plugins/vueFactory';
import VueTippy, { TippyComponent } from 'vue-tippy';
import ProductVariantsTable from './components/product-variants-table.vue';
import store from '../../store';
import wiswiseproxyclient from '../../plugins/wiswiseproxyclient';
import filters from '../../plugins/filters';
import toastNotifications from '../../plugins/toastNotifications';
import debounce from '../../plugins/debounce';

const productVariantsTableElement = document.getElementById(
  'product-variants-table'
);

if (productVariantsTableElement) {
  const baseShapeData = JSON.parse(
    productVariantsTableElement.getAttribute('data-baseshapedata')
  );
  const baseURL = productVariantsTableElement.getAttribute('data-baseurl');
  const culture = productVariantsTableElement.getAttribute('data-culture');
  const isAuthenticated =
    productVariantsTableElement
      .getAttribute('data-isauthenticated')
      .toLowerCase() === 'true';

  if (!baseShapeData || !baseURL || !culture) console.warn('Missing arguments');

  Vue.use(VueTippy);
  Vue.component('Tippy', TippyComponent);

  Vue.use(wiswiseproxyclient, {
    config: {
      baseURL
    }
  });

  Vue.use(filters, { culture });

  Vue.use(toastNotifications);

  Vue.use(debounce);

  // eslint-disable-next-line no-new
  new Vue({
    el: productVariantsTableElement,
    created: function() {
      this.$store.commit('setCulture', culture);
      this.$store.commit('setIsAuthenticated', isAuthenticated);
      this.$store.commit('webshop/setBaseShapeData', baseShapeData);
    },
    render: h => h(ProductVariantsTable),
    store
  });
}
